const state = {
    time: "0秒钟",
    progressBar: 0,
    total: '',
    update: '',
    allNu: '',
    addNum: '',
    listData: [],
    changeProductid2: [],
}
const getters={

}
const mutations={
  changeTotal(state,e) {
    state.total = e
  },
  changeUpdate(state,e) {
    state.update = e
  },
  changeProgressBar(state) {
    state.allNu = state.update/state.total
    if (state.allNu) {
      // console.log(state.allNu)
      state.progressBar = Math.ceil(state.allNu * 100)
    } else {
      state.progressBar = 0
    }
  },
  changeTime(state) {
    state.addNum = state.total - state.update
    if (state.addNum * 5 < 60) {
      state.time = state.addNum * 5 + '秒钟'
    } else {
      let n
      n = state.addNum * 5 / 60
      state.time = Math.ceil(n) + '分钟'
    }
  },
  changeListData(state,listData) {
    console.log(listData)
    state.listData = listData
  },
  changeProductid(state,l) {
    console.log(l)
    state.changeProductid2 = l
    console.log(state.changeProductid2)
  }

}
const actions={

}
export default {
    state,
    getters,
    mutations,
    actions
}
